import API from '../..';
const ENTITY = 'companies';

export const getCompany = () => API.get(`/api/v1/${ENTITY}/me/`);
export const updateCompany = (data, id) =>
    API.put(`/api/v1/${ENTITY}/${id}/`, data);
